import { notAllowed, required, Validator } from '@/entities/validation';
import { Role } from './model';

export const validate: Validator<Role> = record => [
  ...required(record.title, 'title'),
  ...required(record.permissions, 'permissions'),
  ...notAllowed(record.title, ['Administrator', 'administrator'], 'title'),
];
